import * as Msal from 'msal';
import * as config from '../../../config.json';

// Define the configuration.
const msalConfig: Msal.Configuration = {
  auth: {
    authority: config.auth.authority,
    clientId: config.auth.clientId,
    redirectUri: config.auth.redirectUri
  }
};

// Create the UserAgentApplication instance
const msalInstance = new Msal.UserAgentApplication(msalConfig);

// register redirect call backs for success and error
// TODO: what do we want to do with this? At this point it isn't doing anything because we use the implicit flow.
msalInstance.handleRedirectCallback(
  (
    error: Msal.AuthError | undefined,
    response: Msal.AuthResponse | undefined
  ) => {}
);

export default msalInstance;
